module.exports = __webpack_public_path__ + "static/img/fetal-monitor.c5fa1b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/fetal-monitor.png
// module id = sBeZ
// module chunks = 1